<template>
    <!-- :style="'height:'+wheight+'px'"   :style="'height:'+fheight+'px'"-->
    <div class="fae-comtainer">
        <faeCommon></faeCommon>
        <div class="fae-header" ref="faeheader">
            <search @searchData="searchData"></search>
            <Calendar
                    :default-date="defaultDatetime"
                    :is-show-week-view="true"
                    :isShowSche="true"
                    @confirm="changeDate"
            ></Calendar>
        </div>
        <div class="fae-list">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="getData"
            >
                <fae-item v-for="item in faeLists" :faeLists="item" :search="searchFae"></fae-item>
            </van-list>
            <div v-if="nodata">
                暂无数据
            </div>

        </div>
    </div>
</template>

<script>
    import api from '@/api/fae';

    import search from './components/search'
    import faeItem from './components/faeItem'
    import faeCommon from './components/faeCommon'

    import Calendar from '@/components/Calendar/index.vue'

    export default {
        components: {search, faeItem, faeCommon, Calendar},
        data() {
            return {
                searchDate: '',    // 查询时间
                searchFaeName: '', // 查询FAE名称
                searchProductLine: '', // 查询产品线
                searchSegment: '',       // 查询领域
                searchLocation:'',      // 办公地点
                page: 1,               // 查询页数
                size: 10,              // 查询数量
                loading: false,
                finished: false,
                faeLists: [],     // fae 数据
                total: 0,          // 总数
                nodata: false,
                defaultDatetime: new Date(),
                fheight: null
            }
        },
        mounted() {

            // this.searchDate = this.Common.formatDate(new Date().getTime());
            // this.getData()
            setTimeout(() => {
                this.getHeight();
            }, 0)
        },
        computed: {
            wheight() {
                let h = document.body.clientHeight || document.body.clientHeight || document.documentElement.clientHeight;
                if (h) {
                    return h
                }
            }
        },
        methods: {
            getHeight() {
                let dh = this.$refs.faeheader.offsetHeight;
                this.fheight = this.wheight - dh
            },
            oncancel() {
                this.initData();
                this.getData()
            },
            searchData(data) {
                this.initData();
                this.searchFaeName = data.faeValue;
                this.searchProductLine = data.prolineValue;
                this.searchSegment = data.segment;
                this.searchLocation = data.location;
                this.getData()
            },
            changeDate(date) {
                this.initData();
                let $data = new Date(date.year, date.month, date.day);
                this.searchDate = this.Common.formatDate($data.getTime());
                this.getData()
            },
            initData() {
                this.loading = true;
                this.total = 0;
                this.page = 1;            // 查询页数
                this.size = 10;             // 查询数量
                this.faeLists = [];    // fae 数据
                this.total = 0;        // 总数
                this.nodata = false;
                this.finished = false;
            },
            getData() {
                this.loading = true;
                let params = {
                    date: this.searchDate,
                    name: this.searchFaeName,
                    productLine: this.searchProductLine,
                    segment: this.searchSegment,
                    actualLocation:this.searchLocation,
                    page: this.page,
                    size: this.size,
                    faeId: ''
                };
                this.searchFae = params;

                api.getDataFae(params).then(res => {
                    let $data = res.data;
                    if ($data && $data.total) {
                        this.page++;
                        this.nodata = false;
                        this.loading = false;
                        this.total = $data.total;
                        this.faeLists = this.faeLists.concat($data.records);

                        // if (this.faeLists.length > 0 && (this.faeLists.length >= this.total)) {
                        //     this.finished = true;
                        // }

                        if ($data.current >= $data.pages) {
                            this.finished = true;
                        }

                    } else {
                        this.faeLists = [];
                        this.loading = false;
                        this.finished = true;
                        this.nodata = false;

                    }
                })
            },


            // onLoadMore() {
            //     console.log("onLoadMore")
            //     if(this.total>this.faeLists.length){
            //         this.page++;
            //         this.getData()
            //     }else{
            //         this.finished = true;
            //     }
            // },

            /* axios 原生方法
            getDataFae() {
                let post_data = new FormData();
                 let searchDate = this.searchDate;
                 let searchFaeName = this.searchFaeName;
                 let searchProductLine = this.searchProductLine;
                 let page = this.page;
                 let size = this.size;
                 let that = this;
                axios.post(this.CoreNew.OA_API_IP + `joa-crm/crm/fae/query?date=${searchDate}&name=${searchFaeName}&productLine=${searchProductLine}&page=${page}&size=${size}`, post_data, {
                    headers: {'Authorization': JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    let $data = response.data
                    // console.log($data)
                    if ($data && $data.status === 20000 && $data.flag && $data.data.total > 0) {
                        that.nodata = false;
                        that.faeLists = $data.data.records;
                        console.log(that.faeLists);
                    } else {
                        that.faeLists = [];
                        that.nodata = true;
                    }
                })
            }*/
        }
    }

</script>

<style scoped lang="less">
    .fae-comtainer {
        position: relative;
        
        .fae-list {
            /*position: absolute;*/
            /*overflow-y: scroll;*/
            /*width: 100%;*/
        }

        /deep/ .van-popup {
            /deep/ .van-ellipsis {
                font-size: 14px;
            }
        }

    }


</style>
